import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import MainLayout from '../components/layout/MainLayout'
import WorkWizard from '../components/work/WorkWizard'

export default function WorkCreate() {
  const navigate = useNavigate()

  return (
    <MainLayout>
      <div style={{ padding: '24px', maxWidth: '860px', margin: '0 auto' }}>
        <button
          onClick={() => navigate('/work')}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'transparent', border: 'none', color: 'var(--text-secondary)', fontSize: '13px', cursor: 'pointer', padding: '0 0 16px' }}
        >
          <ArrowLeft size={14} />
          Back to Work
        </button>
        <h1 style={{ margin: '0 0 24px', fontSize: '20px', fontWeight: 700, color: 'var(--text-primary)' }}>
          Create New Job
        </h1>
        <WorkWizard />
      </div>
    </MainLayout>
  )
}
